import reduceReducers from 'reduce-reducers'

import { default as DetailReducer } from './CareDetail'
import { default as SearchReducer } from './CareSearch'
import { default as PrescriptionReducer } from './Prescription'
import { default as PublicCareReducer } from './PublicCare'
import { default as CareRatesReducer } from './CareRates'
import { default as RatingAreaReducer } from './RatingArea'
import { default as MemberCommunicationReducer } from './MemberCommunication'
import { default as PharmacyReducer } from './Pharmacy'

export * from './CareDetail'
export * from './CareSearch'
export * from './Prescription'
export * from './PublicCare'
export * from './CareRates'
export * from './RatingArea'
export * from './MemberCommunication'
export * from './Pharmacy'

// Export types and initialState from separate file to avoid circular dependencies
import { types, initialState } from './types'
export { types, initialState }
export default reduceReducers(
  DetailReducer,
  SearchReducer,
  PrescriptionReducer,
  PublicCareReducer,
  CareRatesReducer,
  RatingAreaReducer,
  MemberCommunicationReducer,
  PharmacyReducer,
  // last arg MUST be shared state
  initialState,
)
